import * as React from 'react'

import MessageListenerContainer from 'app/containers/common/messageListenerContainer'
import { AppRoutes } from './AppRoutes'
import { withAuth, AuthContextProps } from 'react-oidc-context'
import { AppLoader } from './AppLoader'
import { configureToasts } from '@/lib/toasts/api'
import { ToasterHost } from '@/lib/toasts/ToasterHost'
import { RouteComponentProps, withRouter } from '@/app/navigation/withRouter'
//import { VersionUpdateBanner } from '@/modules/shared/components/VersionUpdateBanner'

configureToasts({
  position: 'top-right',
  duration: 1200,
  dismissible: true,
  showProgress: true,
  pauseOnHover: true,
  maxPerStack: 6,
})

type Props = {}
type State = {}

type MatchParams = {}

class App extends React.Component<
  Props & { auth: AuthContextProps } & RouteComponentProps<MatchParams>,
  State
> {
  private displaySimpleSettings = (): boolean => {
    return this.props.history.location.pathname.includes('/companySelection')
  }

  private readonly displayNewLayout = (): boolean => {
    return this.props.history.location.pathname.includes('/creator')
  }

  render() {
    const shouldDisplaySimpleSettings = this.displaySimpleSettings()
    const shouldDisplayNewLayout = this.displayNewLayout()
    const { auth } = this.props

    return (
      <div
        data-theme="myTheme"
        // className={!shouldDisplayNewLayout ? `bodyUI` : ''}
      >
        <ToasterHost zIndex={9999} defaultPosition="top-right" />
        {/* <VersionUpdateBanner /> */}

        <MessageListenerContainer />

        {/* Nie montuj tras, dopóki react-oidc-context nie skończy inicjalizacji
            (w tym wymiany ?code= na token po powrocie z Keycloaka). Bez tego
            /postLogin montował się w trakcie wymiany kodu i jego signinSilent/
            signinRedirect przerywał ją, zapętlając logowanie. */}
        {auth.isLoading ? (
          <AppLoader />
        ) : (
          <AppRoutes authenticated={auth.isAuthenticated} />
        )}

        {/* <GenericErrorModal /> */}
      </div>
    )
  }
}

// `withAuth` wstrzykuje `auth` jako pojedynczy props (`{...props, auth}`), ale
// deklaruje się jako `Omit<P, keyof AuthContextProps>` - czyli usuwa z sygnatury
// rozłożone pola, a nie samo `auth`. Rzutowanie prostuje ten rozjazd biblioteki.
export default withAuth(withRouter(App)) as React.ComponentType<Props>
